(function (root, factory) {
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = factory();
  } else {
    var api = factory();
    var axios = root.themeVendor && root.themeVendor.axios ? root.themeVendor.axios : root.axios;
    api.patchAxiosCartAdd({ window: root, axios: axios });
  }
})(typeof window !== 'undefined' ? window : globalThis, function () {
  function patchAxiosCartAdd(options) {
    var win = options.window;
    var axios = options.axios;
    if (!axios || !axios.post || axios.__customOrderDataCartAddPatched) return;
    axios.__customOrderDataCartAddPatched = true;
    var post = axios.post.bind(axios);
    axios.post = function (url, body, config) {
      var headers = config && config.headers || {};
      var contentType = headers['Content-Type'] || headers['content-type'] || '';
      if (!/\/cart\/add\.js(?:\?|$)/.test(url) || typeof body !== 'string' || contentType.indexOf('application/x-www-form-urlencoded') === -1) {
        return post(url, body, config);
      }
      var custom = win.themeCustomValidation;
      var params = custom && custom.cleanFormParams ? custom.cleanFormParams(body) : new URLSearchParams(body);
      var expedite = params.get('properties[Expedite Build]') || '';
      if (!/^yes/i.test(expedite.trim())) return post(url, params.toString(), config);
      var form = custom && custom.__lastAddToCartForm;
      // A Shopify input named id shadows HTMLFormElement.id.
      var formId = form && form.getAttribute('id');
      var field = formId && win.document.querySelector('[data-wilbers-expedite-prop][form="' + formId + '"]');
      var container = field && field.closest('[data-wilbers-expedite]');
      if (!container && form) container = form.querySelector('[data-wilbers-expedite]');
      var variantInput = container && container.querySelector('[data-wilbers-expedite-hidden-variant]');
      var expediteId = variantInput && variantInput.value || container && container.getAttribute('data-wilbers-expedite-id');
      if (!expediteId) return Promise.reject({ data: { description: 'The expedite option is unavailable. Please choose No or contact us.' } });
      var quantity = Math.max(1, parseInt(params.get('quantity'), 10) || 1);
      var properties = {};
      params.forEach(function (value, key) {
        var match = /^properties\[(.*)\]$/.exec(key);
        if (match) properties[match[1]] = value;
      });
      var item = { id: params.get('id'), quantity: quantity, properties: properties };
      if (params.get('selling_plan')) item.selling_plan = params.get('selling_plan');
      var extra = { id: expediteId, quantity: quantity, properties: { Product: container.getAttribute('data-wilbers-product-title') || '' } };
      return post(url, { items: [item, extra] }, Object.assign({}, config, { headers: Object.assign({}, headers, { 'Content-Type': 'application/json' }) })).then(function (response) {
        var added = response.data.items.find(function (addedItem) { return String(addedItem.id) === String(item.id); });
        return Object.assign({}, response, { data: added || response.data.items[0] });
      });
    };
  }
  return { patchAxiosCartAdd: patchAxiosCartAdd };
});
